export default __webpack_public_path__ + "static/media/cp_geo_bi.36e260ce.svg";